import React from 'react'
import {
  IconButton,
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText,
  List,
  Link
} from '@material-ui/core'
import PowerSettingsNewOutlinedIcon from '@material-ui/icons/PowerSettingsNewOutlined'
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined'
import AttachMoneyOutlinedIcon from '@material-ui/icons/AttachMoneyOutlined'
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined'
import PersonAddOutlinedIcon from '@material-ui/icons/PersonAddOutlined'
import AccountTreeIcon from '@material-ui/icons/AccountTree'
import ContactsOutlinedIcon from '@material-ui/icons/ContactsOutlined'

import { Link as Linked } from 'react-router-dom'
import ViewQuiltIcon from '@material-ui/icons/ViewQuilt'

import { Theme } from '../../styles/'

const csrfToken = ''

export const AdminMenuList = () => {
  return (
    <div>
      <Divider />

      <List className="list-style">
        <li>
          <Link className="link-style" href="/lab">
            <ListItem button key="portal">
              <ListItemIcon className="icon">
                <ViewQuiltIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Lab" secondary="Dashboard" />
            </ListItem>
          </Link>
          <Link className="link-style" href="/admin">
            <ListItem button key="admin">
              <ListItemIcon className="icon">
                <SettingsOutlinedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Admin" secondary="Dashboard" />
            </ListItem>
          </Link>
          <Divider />
          <Linked className="link-style" to="/admin/users">
            <ListItem button key="users">
              <ListItemIcon className="icon">
                <AccountCircleOutlinedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="List" secondary="All Users" />
            </ListItem>
          </Linked>
          <Linked className="link-style" to="/admin/user/create">
            <ListItem button key="create-new-user">
              <ListItemIcon className="icon">
                <PersonAddOutlinedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Create" secondary="New User" />
            </ListItem>
          </Linked>
          <Divider />
          <Linked className="link-style" to="/admin/clients">
            <ListItem button key="clients">
              <ListItemIcon className="icon">
                <ContactsOutlinedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="List" secondary="All Clients" />
            </ListItem>
          </Linked>
          <Linked className="link-style" to="/admin/client/create">
            <ListItem button key="create-client">
              <ListItemIcon className="icon">
                <AccountTreeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Create" secondary="New Client" />
            </ListItem>
          </Linked>
          <Divider />
          <Link className="link-style" href="/admin/treasury">
            <ListItem button key="Finance">
              <ListItemIcon className="icon">
                <AttachMoneyOutlinedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Finance" />
            </ListItem>
          </Link>
          <Divider />
          <ListItem button key="Toggle Theme">
            <ListItemIcon className="icon">
              <Theme />
            </ListItemIcon>
            <ListItemText primary="Toggle Theme" />
          </ListItem>
          <form action="/auth/logout" method="POST">
            <input type="hidden" name="_token" value={csrfToken} />
            <ListItem button key="Logout">
              <ListItemIcon className="icon">
                <IconButton
                  style={{ color: '#e3342f', left: '-3px', outline: 'none' }}
                  size="small"
                  aria-label="logout"
                  type="submit">
                  <PowerSettingsNewOutlinedIcon fontSize="small" />
                </IconButton>
              </ListItemIcon>
              <ListItemText
                style={{ color: '#e3342f', paddingLeft: '0px' }}
                primary="Logout"
              />
            </ListItem>
          </form>
        </li>
      </List>
    </div>
  )
}

export default AdminMenuList
